var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 70,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 72,
    width: 79,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#000",
    ry: 34.44439,
    rx: 38.14809,
    id: "svg_81",
    cy: 35,
    cx: 38.31481,
    strokeWidth: 0.5,
    fill: "#0c00cd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    id: "svg_80"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9689968395997007,0,0,0.9689968395997007,0,0) ",
    id: "svg_59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_61",
    d: "m24.73181,36.11983l3.59,0l1.7,-1.71a1,1 0 0 1 0.71,-0.29l3,0a1,1 0 0 1 0.45,0.11l1.35,0.67l2.49,-2.49a1,1 0 0 1 0.71,-0.29l5,0a1,1 0 0 1 0.71,0.29l2.56,2.57l2.41,-0.81a1,1 0 0 1 0.87,0.12l2.75,1.83l1.7,0l0,-6l-30,0l0,6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_62",
    d: "m24.73181,24.11983l30,0l0,-6l-30,0l0,6zm26,-4l2,0l0,2l-2,0l0,-2zm-4,0l2,0l0,2l-2,0l0,-2zm-4,0l2,0l0,2l-2,0l0,-2zm-16,0l2,0l0,2l-2,0l0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_63",
    d: "m26.73181,14.11983l26,0l0,2l-26,0l0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_64",
    d: "m24.73181,12.11983l30,0l0,-6l-30,0l0,6zm26,-4l2,0l0,2l-2,0l0,-2zm-4,0l2,0l0,2l-2,0l0,-2zm-4,0l2,0l0,2l-2,0l0,-2zm-16,0l2,0l0,2l-2,0l0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_65",
    d: "m26.73181,26.11983l26,0l0,2l-26,0l0,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_66",
    d: "m31.73181,44.11983l0,-2a3,3 0 0 0 -6,0l0,2a3,3 0 0 0 6,0zm-2,0a1,1 0 0 1 -2,0l0,-2a1,1 0 0 1 2,0l0,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_67",
    d: "m43.73181,51.11983a3,3 0 0 0 -6,0l0,2a3,3 0 0 0 6,0l0,-2zm-2,2a1,1 0 0 1 -2,0l0,-2a1,1 0 0 1 2,0l0,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_68",
    d: "m46.73181,56.11983a3,3 0 0 0 -3,3l0,2a3,3 0 0 0 6,0l0,-2a3,3 0 0 0 -3,-3zm1,5a1,1 0 0 1 -2,0l0,-2a1,1 0 0 1 2,0l0,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_69",
    d: "m50.73181,43.11983l0,-2a3,3 0 0 0 -6,0l0,2a3,3 0 0 0 6,0zm-4,0l0,-2a1,1 0 0 1 2,0l0,2a1,1 0 0 1 -2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_70",
    d: "m39.11181,37.19983a1,1 0 0 0 -1.09,0.21l-2,2l1.42,1.42l0.29,-0.3l0,2.59l-1,0l0,2l4,0l0,-2l-1,0l0,-5a1,1 0 0 0 -0.62,-0.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_71",
    d: "m51.73181,48.11983a1,1 0 0 0 -0.62,-0.92a1,1 0 0 0 -1.09,0.21l-2,2l1.42,1.42l0.29,-0.3l0,2.59l-1,0l0,2l4,0l0,-2l-1,0l0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_72",
    d: "m37.73181,59.11983a1,1 0 0 0 -0.62,-0.92a1,1 0 0 0 -1.09,0.21l-2,2l1.42,1.42l0.29,-0.3l0,2.59l-1,0l0,2l4,0l0,-2l-1,0l0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_73",
    d: "m32.73181,49.11983a1,1 0 0 0 -0.62,-0.92a1,1 0 0 0 -1.09,0.21l-2,2l1.42,1.42l0.29,-0.3l0,2.59l-1,0l0,2l4,0l0,-2l-1,0l0,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_74",
    d: "m16.73181,43.11983l-4,0l0,9l-3,0l5,5l5,-5l-3,0l0,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_75",
    d: "m66.73181,40.11983l0,-9l-4,0l0,9l-3,0l5,5l5,-5l-3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_76",
    d: "m11.73181,32.11983l2,0l0,8l-2,0l0,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_77",
    d: "m15.73181,29.11983l2,0l0,11l-2,0l0,-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_78",
    d: "m65.73181,20.11983l2,0l0,8l-2,0l0,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_79",
    d: "m61.73181,17.11983l2,0l0,11l-2,0l0,-11z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLoss);
export default __webpack_public_path__ + "static/media/data-loss.2b37990ec8406982c5ad927a1d637b6c.svg";
export { ForwardRef as ReactComponent };